import { createContext } from "react";
import { ThemeProps } from "../models/theme";

export interface ThemeContextInterface {
  theme: ThemeProps;
  clearData: () => void;
  /* eslint-disable */
  updateTheme: (data: ThemeProps) => void;
}

export const themeContextDefaults: ThemeContextInterface = {
  theme: {
    id: "0",
    url: "",
    url_type: "GROUP",
    color_primary: "",
    color_secondary: "",
    color_tertiary: "",
    light_gray: "#FCFCFC",
    logo_for_payment_portal: "",
    is_active: true,
  },
  clearData: () => {
    //function to clear Data
  },
  updateTheme: () => {
    //function to clear Data
  },
};

export const ThemeContext =
  createContext<ThemeContextInterface>(themeContextDefaults);
